<script>
import Favorite from "../lib/favorite.vue"

export default {

  components: {Favorite},
  props: {
    talk: {type: Object, required: true},
    listDisplay: {type: Boolean, default: false},
    languageDisplay: {type: Boolean, default: true},
  },

  data() {
    return {
      talkExpanded: !this.listDisplay,
      showRegisterAlert: false,
    }
  },

  computed: {
    userHasPermission() {
      if (this.talk.ticket_category && !this.talk.hasOwnProperty('registered_mm_user_ids')) {
        this.$emit('talk-detail-required')
        return false
      } else if (this.talk.ticket_category) {
        if (this.talk.ticket_valid)
          return true
        return false
      }
      return true
    },
    userIsLoggedIn() {
      return this.$storage.getToken()
    }
  },

  methods: {

    talkUrl: function() {
      let sn = this.$route.params['shortName']
      return sn ? `/${sn}/talks/${this.talk.id}` : `/talks/${this.talk.id}`
    },

    parseDate: function (datetimeStr, locale = 'de') {
      const opts = {
        year: "numeric",
        month: "short",
        day: "numeric",
        timeZone: 'Europe/Berlin',
      }
      return new Date(datetimeStr).toLocaleString(locale, opts)
    },

    displayTime(datetimeStr, locale = 'de') {
      const opts = {
        hour: "numeric",
        minute: "numeric",
        timeZone: 'Europe/Berlin',
      }
      return new Date(datetimeStr).toLocaleString(locale, opts)
    },
  },
}
</script>

<template>
  <div class="d-flex flex-column">

    <h4> 
      <template v-if="listDisplay">
        <router-link v-if="languageDisplay" :to="talkUrl()">{{talk.title}} ({{talk.language}})</router-link>
        <router-link v-else :to="talkUrl()">{{talk.title}}</router-link>
      </template>
      <template v-else>
        <span v-if="languageDisplay">{{talk.title}} ({{talk.language}})</span>
        <span v-else>{{talk.title}}</span>
      </template>

      <favorite v-if="userHasPermission" attr="session" :value="talk.content_code" :obj="talk"
       extra-css="p-2"
       @favorite-changed="$emit('favorite-changed', $event)" />
      <i v-else class="far fa-bookmark text-warning p-2" @click.prevent="showRegisterAlert=!showRegisterAlert"></i>
    </h4>

    <div class="row">

      <div class="col col-6">
        <div v-if="showRegisterAlert" class="alert alert-danger">
          <template v-if="userIsLoggedIn">
            <template v-if="talk.ticket_shop_url">
              Sie müssen sich für den Vortrag <a :href="talk.ticket_shop_url" target="_blank">registrieren</a>!
            </template>
            <template v-else>
              Die Registrierung ist in Kürze verfügbar!
            </template>
          </template>
          <template v-else>
              Sie müssen für den Vortrag <a href="/accounts/login">anmeldet</a>  (logged in) sein!
          </template>
        </div>

        <div class="badge bg-secondary text-dark">
          <div class="font-weight-bold mb-0" style="font-size:larger">
            {{parseDate(talk.start_datetime)}} • {{displayTime(talk.start_datetime)}} - {{displayTime(talk.end_datetime)}}
          </div>
        </div>
      </div>

      <div class="col col-4">
        <div class="font-weight-bold mb-0" style="font-size:larger">
          {{talk.location.name}}
        </div>
      </div>

      <div class="col col-2 text-end">

        <button class="btn btn-outline" v-if="listDisplay && (talk.description || talk.speakers && talk.speakers.length)"
        @click.prevent="talkExpanded=!talkExpanded">
          <i v-if="talkExpanded"  class="fas fa-chevron-down"></i>
          <i v-else class="fas fa-chevron-right"></i>
        </button>
      </div>

    </div>

    <div v-if="talk.description" class="my-2" :class="{ 'two-lines': !talkExpanded }">
      <span class="overflow-ellipsis" v-html="talk.description"></span>
    </div>

    <div v-if="talkExpanded" class="d-flex my-3" style="flex-direction: row ;gap: 16px; flex-wrap: wrap;">

      <speaker-thumb v-for="speaker in talk.speakers" :key="speaker.id"
        :speaker="speaker" @speaker-click="$emit('speaker-click', $event)" />

      <speaker-thumb v-for="chair in talk.chair_persons" :key="chair.id"
        :speaker="chair" :is-moderator="true" @speaker-click="$emit('speaker-click', $event)" />

      <div v-if="talk.related_image" class="d-flex flex-column align-items-center" style="gap: 15px">
        <img width="100" height="60" style="object-fit: cover" :src="talk.related_image" />
        <div>Session-Sponsor</div>
      </div>
    </div>

    <div class="d-flex flex-wrap" style="gap: 0.25rem">
      <div v-for="stream in talk.streams" :key="stream.id">
        <a href="" class="badge bg-primary"
          @click.prevent="$emit('stream', stream)">
          {{stream.name}}
        </a>
      </div>
    </div>
  </div>
</template>

<style scoped>
.badge {
  text-decoration: none;
}
.two-lines {
  max-height: 2.4em;
  overflow: hidden;
}
.overflow-ellipsis {
  text-overflow: ellipsis;
}
</style>
